import React, { Component } from 'react';
import { connect } from 'react-redux';
import { show } from 'redux-modal';
import moment from 'moment';
import { push } from 'react-router-redux';
import { toastr } from 'react-redux-toastr';
import _ from 'lodash';
import { Row, Col } from 'react-bootstrap';

import { setLoader, removeLoader } from '../../../actions';
import { AdvertiserApi } from '../../../api';
import { CampaignIndexTable } from '../campaigns';
import WelcomePopup from './WelcomePopup';
import { DateRange } from '../../common';
import { calendarRanges } from '../../../utils/helpers/calendar_ranges';
import { convertMillsToDollars } from '../../../utils/helpers/currency';

class SelfServeDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      start_date: moment().startOf('month'),
      end_date: moment().endOf('month')
    };
  }
  componentDidMount() {
    this.fetchCampaigns();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.account.uuid !== this.props.account.uuid) {
      this.fetchCampaigns();
    }
  }

  fetchCampaigns(params = {}) {
    const { account, dispatch } = this.props;
    const { start_date, end_date } = this.state;
    if (account.uuid) {
      const data = {
        ...params,
        account_id: account.uuid,
        since: start_date.format('YYYY-MM-DD'),
        until: end_date.format('YYYY-MM-DD')
      };

      dispatch(AdvertiserApi.actions.campaigns.get(data, (error, success) => {
        if (success.data.length === 0) {
          this.showWizardPopup();
        } else {
          const reportData = {
            ...params,
            account_id: account.uuid,
            since: start_date.format('YYYY-MM-DD'),
            until: end_date.format('YYYY-MM-DD')
          };
          dispatch(AdvertiserApi.actions.campaignReports.get(reportData));
        }
      }));
    }
  }

  redirectToWizard() {
    const { dispatch, account } = this.props;
    dispatch(push(`/advertiser/home/accounts/${account.slug}/campaigns/wizard`));
  }

  showWizardPopup() {
    const { dispatch, user } = this.props;

    dispatch(show('WelcomePopModal', { user, redirectToWizard: this.redirectToWizard.bind(this) }));
  }

  handlePauseCampaign(campaign, action) {
    const { dispatch, account, campaigns } = this.props;
    const args = [account.uuid, campaign.uuid, {
      status: action === 'Pause' ? 'paused' : 'active'
    }];
    document.body.click();
    dispatch(setLoader('CampaignStatusUpdate'));
    dispatch(AdvertiserApi.actions.campaignUpdate.patch(...args, (error, success) => {
      dispatch(removeLoader('CampaignStatusUpdate'));
      if (success) {
        const collection = [...campaigns.data].map((obj) => {
          return obj.uuid === success.data.uuid ? success.data : obj;
        });

        dispatch({
          type: AdvertiserApi.events.campaigns.actionSuccess,
          syncing: false,
          data: { ...campaigns, data: collection, meta: { ...campaigns.meta } }
        });
        toastr.success(`Campaign ${action === 'Pause' ? 'paused' : 'resumed'} successfully`);
      }
    }));
  }

  handleRemoveCampaign(campaign) {
    const { dispatch, account, campaigns } = this.props;
    document.body.click();
    dispatch(AdvertiserApi.actions.campaignDelete.post(account.uuid, campaign.uuid, (error, success) => {
      if (success) {
        const collection = [...campaigns.data].filter((obj) => {
          return obj.uuid !== success.data.uuid;
        });
        dispatch({
          type: AdvertiserApi.events.campaigns.actionSuccess,
          syncing: false,
          data: { ...campaigns, data: collection, meta: { ...campaigns.meta } }
        });
        toastr.success('Campaign removed successfully');
      }
    }));
  }

  handleDateApply(d) {
    this.setState({ start_date: d.startDate, end_date: d.endDate }, () => {
      this.fetchCampaigns({
        start_date: d.startDate.format('ddd, DD MMM YYYY'),
        end_date: d.endDate.format('ddd, DD MMM YYYY'),
      });
    });
  }

  render() {
    const { account, user, accountTotal, useDemoData, campaignReportsIsLoading, campaignsIsLoading } = this.props;
    return (
      <div>
        <div className="row">
          <div className="col-lg-12 m-b-lg">
            <h2>Hey <span className="text-navy">{user.name}</span>, Welcome to JobAdX!</h2>
          </div>
        </div>
          <div>
            <Row>
              <Col md={12} className='pull-left'>
                <DateRange
                  key='daterange-ad-cu-dash'
                  defaultChosenLabel='This Month'
                  opens='right'
                  startDate={this.state.start_date}
                  endDate={this.state.end_date}
                  ranges={calendarRanges}
                  onApply={this.handleDateApply.bind(this)}
                  disabled={useDemoData}
                />
              </Col>
            </Row>
            <br />
            <div className="row">
              <div className="col-md-4 col-sm-6 col-xs-12"><div className="ibox">
                <div className="ibox-title"><h5>Total Clicks</h5></div>
                <div className="ibox-content"><h1>{!useDemoData ? accountTotal.clicks : 20046}</h1></div>
              </div></div>
              <div className="col-md-4 col-sm-6 col-xs-12"><div className="ibox">
                <div className="ibox-title"><h5>Total Impressions</h5></div>
                <div className="ibox-content"><h1>{!useDemoData ? accountTotal.impressions : 77908}</h1></div>
              </div></div>
              <div className="col-md-4 col-sm-6 col-xs-12"><div className="ibox">
                <div className="ibox-title"><h5>Total Spent</h5></div>
                <div className="ibox-content"><h1>${!useDemoData ? convertMillsToDollars(accountTotal.spend) : 23000}</h1></div>
              </div></div>
            </div>
            <div className="row">
              <div className="col-xs-12">
                <div className='ibox'>
                  <div className='ibox-title border-bottom'>
                    <h5>Campaigns</h5>
                  </div>
                  <div
                    className={`p-b-lg ibox-content${(campaignReportsIsLoading && campaignsIsLoading) ? ' sk-loading' : ''}`}
                  >
                    <CampaignIndexTable account={account} useDemo />
                  </div>
                </div>
              </div>
            </div>
          </div>
        <WelcomePopup className="test-2" />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    loader,
    user: { data: user },
    advertiser: {
      campaigns: {
        data: campaigns,
        loading: campaignsIsLoading
      },
      campaignReports: {
        data: campaignReports,
        loading: campaignReportsIsLoading
      }
    }
  } = state;
  const { account } = ownProps;

  const totaledReports = {};
  const accountTotal = {
    spend: 0,
    clicks: 0,
    impressions: 0
  };

  let useDemoData = true;

  const sortedReports = [];

  if (campaignReports.data && campaigns.data) {
    useDemoData = campaigns.data.length <= 0;

    campaignReports.data.forEach((currentValue) => {
      totaledReports[currentValue.referencenumber] = totaledReports[currentValue.referencenumber] ||
      {
        count: 0,
        clicks: 0,
        conversions: 0,
        impressions: 0,
        spend: 0,
      };

      totaledReports[currentValue.referencenumber].count++;
      totaledReports[currentValue.referencenumber].clicks += currentValue.clicks;
      totaledReports[currentValue.referencenumber].conversions += currentValue.conversions;
      totaledReports[currentValue.referencenumber].impressions += currentValue.impressions;
      totaledReports[currentValue.referencenumber].spend += currentValue.spend;

      accountTotal.spend += currentValue.spend;
      accountTotal.clicks += currentValue.clicks;
      accountTotal.impressions += currentValue.impressions;
    });

    campaigns.data.forEach((campaign) => {
      sortedReports.push({
        ...totaledReports[campaign.referencenumber],
        ...campaign
      });
    });
  }

  const totalAds = sortedReports.reduce((a, c) => {
    return a + c.total_active_ads;
  }, 0);

  return {
    user,
    account,
    accountTotal,
    campaigns,
    campaignsIsLoading,
    campaignReports,
    campaignReportsIsLoading,
    useDemoData,
    totaledReports,
    sortedReports,
    totalAds,
    statusLoading: loader.includes('CampaignStatusUpdate')
  };
};

export default connect(mapStateToProps)(SelfServeDashboard);
